import { message } from 'antd';

export const formatActionText = (action: string): string => {
  const actionMap: Record<string, string> = {
    create: '생성',
    update: '수정',
    delete: '삭제',
    bulk_update: '일괄 수정',
    bulk_delete: '일괄 삭제',
    distribute: '배포',
  };
  return actionMap[action] || action;
};

export const formatObjectTypeText = (objectTypeName: string): string => {
  const modelMap: Record<string, string> = {
    Content: '콘텐츠',
    Series: '시리즈',
    Season: '시즌',
    Playlist: '플레이리스트',
    Tag: '태그',
    People: '인물',
    Contract: '계약',
    Company: '회사',
    User: '사용자',
  };
  return modelMap[objectTypeName] || objectTypeName;
};

export const getActionColor = (action: string): string => {
  const colorMap: Record<string, string> = {
    create: 'green',
    update: 'blue',
    delete: 'red',
    bulk_update: 'orange',
    bulk_delete: 'red',
    distribute: 'purple',
  };
  return colorMap[action] || 'default';
};

export const formatChangedFields = (changedFields: string[] | null): string => {
  if (!changedFields || changedFields.length === 0) return '-';
  return changedFields.join(', ');
};

export const formatDataPreview = (data: Record<string, any> | null): string => {
  if (!data) return '-';

  const preview = JSON.stringify(data, null, 2);
  return preview.length > 100 ? preview.substring(0, 100) + '...' : preview;
};

export const handleActionHistoryError = (error: any): void => {
  console.error('Action History Error:', error);
  message.error('액션 히스토리를 불러오는 중 오류가 발생했습니다.');
};
